import {Component, computed, HostListener, inject} from '@angular/core';
import {Router, RouterOutlet, NavigationEnd} from '@angular/router';
import {NgClass} from '@angular/common';
import {filter, startWith} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';
import {PolarisRoutePaths} from '../../shared/types/common';
import {ChatHistoryComponent} from './components/chat-history/chat-history.component';
import {DashboardType} from '../top-bar-wrapper/top-bar-wrapper.component';
import {map} from 'rxjs';
import {AssetVersionPipe} from '../../pipes/asset-version.pipe';

@Component({
  selector: 'app-copilot-index-screen',
  imports: [RouterOutlet, NgClass, ChatHistoryComponent, AssetVersionPipe],
  templateUrl: './copilot-index-screen.component.html',
  styleUrl: './copilot-index-screen.component.scss'
})
export class CopilotIndexScreenComponent {
  private router = inject(Router);
  currentRoute = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => e.urlAfterRedirects),
      startWith(this.router.url)
    )
  );
  backgroundClass = computed(() => {
    const currentRoute = this.currentRoute() as string;
    const isHomePageOrAlertPage = currentRoute.includes(`/${PolarisRoutePaths.POLARIS_HOME}`) || currentRoute.includes(`/${PolarisRoutePaths.ALERTS}`);
    return isHomePageOrAlertPage
      ? 'background-home'
      : 'background-chat'
  });
  public showChatHistory: boolean = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.chat-history-container') && !target.closest('.copilot-floating-menu-button')) {
      this.showChatHistory = false;
    }
  }

  protected readonly DashboardType = DashboardType;
}
